export default {
  hladanyVyraz: '',
  celex: '',
  eurovoc: '',
  zmluva: '',
  autor: null,
};
